import React from "react";
import { translate } from "./Translation";

export default class PageNotFound extends React.Component {
    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <h1 className="text-center">{translate("Stránka nebola nájdená")}</h1>
                        <h4 className="text-center">
                            {translate("Skontrolujte či ste zadali správnu url adresu alebo sa uistite, že máte dostatočné oprávnenia na zobrazenie tejto stránky.")}
                        </h4>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/base/PageNotFound.js